const COMMAND_PALETTE_OPEN_EVENT = "coval:command-palette-open"

export type CommandPaletteOpenSource = "keyboard-shortcut" | "keyboard-help"

export function dispatchOpenCommandPalette(
  source: CommandPaletteOpenSource = "keyboard-shortcut",
) {
  if (typeof window === "undefined") {
    return
  }

  window.dispatchEvent(
    new CustomEvent(COMMAND_PALETTE_OPEN_EVENT, {
      detail: { source },
    }),
  )
}

export { COMMAND_PALETTE_OPEN_EVENT }
